import base from '../base/base';
import header from '../base/header';
import LazyloadVideo from '../../components/platformPlayer/LazyloadVideo';
import AnchorNav from '../../components/anchor-nav/AnchorNav';
new AnchorNav();



// WEBPACK FOOTER //
// ./assets/layouts/big-board/big-board.js